var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"collapse-button",on:{"click":this.onClick}},[_c('img',{attrs:{"src":this.showButtonIcon}}),_c('span',{staticClass:"collapse-text"},[_vm._v(" "+_vm._s(this.showButtonText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }